var React = require('react');

function Projects12 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#project-12)","fill":"currentColor","key":0},[React.createElement("path",{"d":"M6 0 0 3l6 3 6-3-6-3Z","key":0}),React.createElement("path",{"d":"M1.882 5.06 6 7.117l4.118-2.059L12 6 6 9 0 6l1.882-.94Z","key":1}),React.createElement("path",{"d":"M1.882 8.06 6 10.117l4.118-2.059L12 9l-6 3-6-3 1.882-.94Z","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"project-12"},React.createElement("path",{"fill":"currentColor","d":"M0 0h12v12H0z"})))]);
}

Projects12.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = Projects12;

Projects12.default = Projects12;
